export default __webpack_public_path__ + "static/media/star-background.4145c0a9.png";